import moment from 'moment'

const prepareShow = meeting => {
  meeting.meeting_date = moment(meeting.meeting_date, 'YYYYMMDD').format('DD/MM/YYYY')
  return meeting
}

// const prepareSearch = (search) => {
//   search.generic = search.generic
//   return search
// }

export default {
  prepareShow,
  doFilterSearch () {
    this.setPage(1)
  },
  doClearSearch () {
    this.search.generic = null
    this.doLoadAll()
  },
  showActions (actions) {
    if (actions) {
      this.show = false
    } else {
      this.show = true
    }
  },
  setDoSearch (dt, status) {
    this.search.generic = {
      dt,
      filter: dt,
      years: status
    }
    this.setPage(1)

    this.search.generic = dt
  },
  getYears () {
    this.$http.get('/v1/dweller/meeting/years')
    .then(({data}) => {
      this.years = data
    })
  }
}



// WEBPACK FOOTER //
// ./src/app/dweller/meeting/index/resources/methods.js